export let MapSellerTypeToValiable: { [name: string]: string } = {
  นิติบุคคล: "LegalEntity",
  บุคคลธรรมดา: "Individual",
};
